import { Injectable, SkipSelf } from '@angular/core';
//import { ApiEndPointsOrganization } from '../../common/apiUrls/api-end-points-organization';
import { EnvService } from 'src/app/env.service';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DeleteOrganizationVM } from 'src/app/viewModels/organization/delete-organization-vm';
import { ApiEndPointsOrganization } from '../../common/apiUrls/api-end-points-organization';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {
  private baseUrl:any;
  constructor(@SkipSelf() private _http: HttpClient, 
  private apiAddress: ApiEndPointsOrganization, public env: EnvService,
    private constant: Constants) {
      if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
      this.baseUrl = this.constant.ManageOrganizationPortNumber;
 else
      this.baseUrl = this.env.apiUrl+this.constant.ManageOrganizationPortNumber;
  }

   //private baseUrl = this.env.apiUrl;
  //  private baseUrl = this.env.apiUrl+this.constant.ManageOrganizationPortNumber;

  //private baseUrl = this.constant.ManageOrganizationPortNumber;

   addOrganization(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.addOrganization;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getAllOrganizations(reqVM) {
    const apiCallingURl = this.baseUrl + this.apiAddress.getOrganization;
    return this._http.post(apiCallingURl, reqVM).pipe();
  }

  updateOrganization(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.updateOrganization;
    return this._http.post(apiURL, reqModel).pipe();
  }

  deleteOrganization(deletePermissionVM: DeleteOrganizationVM) {
    const apiCallingURl = this.baseUrl + this.apiAddress.deleteOrganization;
    return this._http.post(apiCallingURl, deletePermissionVM).pipe();
  }

  getCountryList() {
    const apiCallingURl = this.baseUrl + this.apiAddress.getCountryList;
    return this._http.get(apiCallingURl).pipe();
  }

  getStateList(countryId) {
    const apiCallingURl = this.baseUrl + this.apiAddress.getStateList;
    return this._http.post(apiCallingURl, countryId).pipe();
  }

  getCityList(stateId) {
    const apiCallingURl = this.baseUrl + this.apiAddress.getCityList;
    return this._http.post(apiCallingURl, stateId).pipe();
  }

}
